import axios, { AxiosResponse } from 'axios';
import { ITableData } from './find-risk-degree.type';

export const url = '/services/isnaportalsync/open-api/find-risk-degree';

export const getRiskDegreeInfo = (request: any): Promise<AxiosResponse<ITableData>> => {
    return axios.get(`${url}`, {
        params: request,
    });
};